import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M5 5a1 1 0 0 0-.673.26l-.001.001-.002.002-.007.006-.022.021-.08.075q-.102.097-.278.272c-.232.231-.549.561-.893.958-.672.776-1.51 1.877-1.972 3.034a17 17 0 0 0-.853 2.925 18 18 0 0 0-.21 1.314l-.003.022v.007l-.001.003A1 1 0 0 0 0 14v1a1 1 0 0 0 1 1h1.17a3.001 3.001 0 0 0 5.66 0h7.34a3.001 3.001 0 0 0 5.66 0H23a1 1 0 0 0 1-1v-3c0-.905-.482-1.481-.945-1.79a2.5 2.5 0 0 0-.848-.355l-.024-.005-.01-.002h-.005l-.004-.001-4.604-.768L15.55 6.4l-.002-.002-.002-.003-.004-.006-.013-.017a3 3 0 0 0-.175-.204 4 4 0 0 0-.48-.449C14.485 5.407 13.829 5 13 5zm15.83 9H22v-2a.3.3 0 0 0-.008-.074q-.005-.015-.006-.016a.1.1 0 0 0-.04-.036.5.5 0 0 0-.13-.058l-4.98-.83a1 1 0 0 1-.636-.386l-2.246-2.995-.01-.013-.064-.073a2 2 0 0 0-.255-.238C13.391 7.093 13.172 7 13 7H5.402l-.051.05c-.206.207-.49.502-.795.855-.628.724-1.29 1.623-1.628 2.466-.37.926-.605 1.862-.747 2.575A16 16 0 0 0 2.007 14h.164a3.001 3.001 0 0 1 5.658 0h7.342a3.001 3.001 0 0 1 5.658 0M5 14a1 1 0 1 0 0 2 1 1 0 0 0 0-2m13 0a1 1 0 1 0 0 2 1 1 0 0 0 0-2",
      "clip-rule": "evenodd"
    }, null, -1)
  ]))]))
}
export default { render: render }